import axios from 'axios';
const API_URL = process.env.REACT_APP_API_ENDPOINT;
axios.defaults.withCredentials = true;

export const getGraphicalSignupStatistics = async (values) => {
    const res = await axios.post(`${API_URL}signup-account-report/graphical-statistics`, values);
    return res;
};
export const getDataSignupStatistics = async (values) => {
    const res = await axios.post(`${API_URL}signup-account-report/data-statistics`, values);
    return res;
};
